/**
 * Sneaky util to wrap around strings, so `ember-intl-analyzer`
 * recognizes them as intl keys.
 */
export const t = (intlKey: string) => {
  return intlKey;
};
